import React, { useState, useRef } from 'react';
import { useDispatch } from "react-redux";
import 'react-loading-skeleton/dist/skeleton.css';
import { createacademic } from '../../ReduxToolkit/Slice/Academic/Academic';
import JoditEditor from 'jodit-react';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import PageTitle from '../../components/Title/PageTitle';
function AcademicForm() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null);
    const [Image, setImage] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isDescriptionValid, setIsDescriptionValid] = useState(true);

    // create
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!description) {
            setIsDescriptionValid(false);
            alert("Description is required")
            return;

        }
        setIsDescriptionValid(true);
        const formData = new FormData();
        formData.append('Image', Image === null ? "" : Image);
        formData.append('title', title);
        formData.append('description', description);
        dispatch(createacademic(formData));
        closeButtonRef.current.click();
        setImage(null);
        setTitle("");
        setDescription("");
    };
    return (
        <>
            <Button
                data-bs-toggle="modal"
                data-bs-target="#exampleModalAcademic"
                children={"Acadamic"}
                icon="plus-circle-fill"
            />
            {/* model */}
            <div
                className="modal fade"
                id="exampleModalAcademic"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <PageTitle className={"modal-title fs-5"} children={"Upload Academic"} />
                            <Button
                                type="button"
                                bgColor='white'
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action="" onSubmit={handleSubmit}>
                                <Input
                                    label="Title"
                                    type="text"
                                    placeholder="Enter title"
                                    value={title}
                                    required
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                                <Input
                                    label="Image"
                                    type="file"
                                    placeholder="Email"
                                    required
                                    onChange={(e) => setImage(e.target.files[0])} />

                                <div className="mb-3 col-lg-12">
                                    <label htmlFor="content" className="form-label">
                                        description
                                    </label>
                                    <JoditEditor
                                        required={true}
                                        value={description}
                                        tabIndex={1} // 
                                        onBlur={newdescription => setDescription(newdescription)}
                                        onChange={newdescription => { }}
                                    />
                                </div>


                                <div className={`modal-footer`}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        ref={closeButtonRef}
                                    >
                                        Close
                                    </button>
                                    <Button type="submit" children={"Upload"} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AcademicForm